import { render } from "./ticket-icon.vue.js?vue&type=template&id=48103c39!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ticket-icon.vue?vue&type=template&id=48103c39"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__